import { useEffect, useState } from "react";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import { ListItem } from "../__shared__/ListItem/ListItem";
import SpecialOffersDrawerPromotion from "./components/SepecialOffersPromotion/SpecialOffersPromotion";
import { Message } from "../../types/types";
import { dispatchCustomEvent } from "../../utils/customEvent/dispatchCustomEvent";

type Props = {
  /**
   * An array of Message objects.
   */
  messages: Message[];
};

export const SpecialOffersUI = ({ messages }: Props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const promotions = getPromoMessaging(messages).promoDrawerMessages;

  useEffect(() => {
    const listener = () => {
      setDrawerIsOpen(true);
    };

    document.addEventListener("TRADE_IN_READ_MORE_EVENT", listener);

    return () => {
      document.removeEventListener("TRADE_IN_READ_MORE_EVENT", listener);
    };
  });

  const dispatchSpecialOffersDrawerEvent = () => {
    dispatchCustomEvent("TRADE_IN_SPECIAL_OFFERS_DRAWER_EVENT");
  };

  const closeDrawerAndOpenTradeInModal = () => {
    setDrawerIsOpen(false);
    dispatchSpecialOffersDrawerEvent();
  };

  if (promotions.length === 0) {
    return null;
  }
  return (
    <>
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={() => {
          setDrawerIsOpen(true);
        }}
        label={
          promotions.length === 1
            ? "Special offer"
            : `Special offers (${promotions.length})`
        }
        data-testid="special-offers-drawer-header"
        showTopBorder={false}
        showBottomBorder={false}
        isOffer
      />

      <Drawer
        isOpen={drawerIsOpen}
        onClose={() => {
          setDrawerIsOpen(false);
        }}
        header={
          promotions.length === 1
            ? "Special offer"
            : `Special offers (${promotions.length})`
        }
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        rootId="page-root"
        isOffersDrawer
      >
        {promotions.map((promotion, index) => (
          <SpecialOffersDrawerPromotion
            key={index}
            promotion={promotion}
            drawerIsOpen={drawerIsOpen}
            onClose={closeDrawerAndOpenTradeInModal}
          />
        ))}
      </Drawer>
    </>
  );
};
